import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

const REGISTER_URL = 'https://partner.activikid.hk/partner-register';

function JoinUsPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NavBar />

      <main style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        backgroundColor: '#fff',
        padding: '2rem',
      }}>
        <img
          src="/Images/loading-cat.png"
          alt="ActiviKid"
          style={{ width: '200px', maxWidth: '50vw', marginBottom: '2rem' }}
        />
        <h2 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#333', marginBottom: '1rem', textAlign: 'center' }}>
          Partner Registration
        </h2>
        <p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem', textAlign: 'center', maxWidth: '480px' }}>
          Click the button below to open the partner registration form.
        </p>
        <a
          href={REGISTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: '#4CAF50',
            color: '#fff',
            padding: '0.9rem 2.4rem',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: 600,
            textDecoration: 'none',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}
        >
          Register as a Partner →
        </a>
      </main>

      <Footer />
    </div>
  );
}

export default JoinUsPage;
